let baseUrl;
switch (process.env.VUE_APP_TITLE) {
  case 'test':
    // 本地
    // baseUrl = "https://www.sclcxx.com/";
    baseUrl = 'https://sclcxx.com/';
    break;
  case 'production':
    baseUrl = 'https://sclcxx.com/';
    break;
  default:
    baseUrl = 'https://sclcxx.com/';
    break;
}
export default baseUrl;
